/** Years in the filter: incorporation year through current year (newest first). */
export function yearsFromIncorporation(
  incorporationDate: string,
  currentCalendarYear: number
): number[] {
  const incYear = new Date(incorporationDate).getFullYear();
  const startYear = Number.isNaN(incYear)
    ? currentCalendarYear
    : Math.min(incYear, currentCalendarYear);
  const years: number[] = [];
  for (let y = currentCalendarYear; y >= startYear; y -= 1) {
    years.push(y);
  }
  return years;
}

/** Summary row when API returns `monthlyBreakdown` as an aggregate object (not monthly rows). */
export type MonthlyBreakdownSummary = {
  totalContribution: number;
  totalTransactions: number;
  avgMonthlyEmployees: number;
  employeeCount: number;
};

export function getMonthlyBreakdownSummary(
  report: Record<string, unknown> | undefined
): MonthlyBreakdownSummary | undefined {
  if (!report) return undefined;
  const mb = report.monthlyBreakdown;
  if (!mb || typeof mb !== "object" || Array.isArray(mb)) return undefined;
  const o = mb as Record<string, unknown>;
  return {
    totalContribution:
      typeof o.totalContribution === "number" ? o.totalContribution : 0,
    totalTransactions:
      typeof o.totalTransactions === "number" ? o.totalTransactions : 0,
    avgMonthlyEmployees:
      typeof o.avgMonthlyEmployees === "number" ? o.avgMonthlyEmployees : 0,
    employeeCount:
      typeof o.employeeCount === "number" ? o.employeeCount : 0,
  };
}

export const CONTRIBUTION_TYPE_LABEL: Record<string, string> = {
  PEN: "Penalty",
  COM: "Contribution",
};

/**
 * Parses an API month ("2025-11-01" or a full ISO string) into a local-time
 * Date on the 1st of that month. Reading the year and month from the string
 * avoids the UTC-midnight shift that moves the month back by one for viewers
 * in timezones behind UTC. Returns an invalid Date for unparseable input.
 */
export function parseMonthLocal(value: string): Date {
  const match = /^(\d{4})-(\d{2})/.exec(value);
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, 1);
  return new Date(NaN);
}

/** "YYYY-MM-01" key for a local year and zero-based month index. */
export function toMonthKey(year: number, monthIndex: number): string {
  return `${year}-${String(monthIndex + 1).padStart(2, "0")}-01`;
}
